export default [
  {
    path: "/activation/:businessId",
    props: true,
    component: () => import("@/views/business/activation/BusinessActivationView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      hideNavShadow: true,
    },
  },
];
